<template>
  <div class="offer-icon">
    <router-link class="h-icon" :to="{name: 'offerConf'}">
      <book-icon title="Bieżąca oferta" />
      <span class="badge">{{productsList.length}}</span>
      <span class="role">oferta</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BookIcon from "vue-material-design-icons/book.vue";

export default {
  components: {
    BookIcon
  },
  computed: {
    ...mapState({
      productsList: state => state.offer.products
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/offer/src/OfferIcon.vue